import Grid from '@mui/material/Grid';
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { CajasEtiquetasList } from '../components/CajasEtiquetasList';
import React from 'react';
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

export const CajasEtiquetas = () => {
    let parametrosUrl = new URLSearchParams(window.location.search);
    var mudanza = parametrosUrl.get('mudanza');
    var ubicacion_temporal = parametrosUrl.get('ubicacion_temporal');
    var retiro_cajas = parametrosUrl.get('retiro_cajas');
    var devolucion_cajas = parametrosUrl.get('devolucion_caja');
    let tituloModulo = "";
    if (mudanza === '1') {
        devolucion_cajas = '0'
        ubicacion_temporal = '0'
        retiro_cajas = '0'
        tituloModulo = "Mudanza de Cajas"
    } else {
        mudanza = '0';
        if (ubicacion_temporal === '1') {
            devolucion_cajas = '0'
            retiro_cajas = '0';
            tituloModulo = "Ubicacion Temporal de Cajas";
        } else if (retiro_cajas === '1') {
            devolucion_cajas = '0'
            ubicacion_temporal = '0';
            tituloModulo = "Retiro de Cajas";
        } else if (devolucion_cajas === '1') {
            retiro_cajas = '0';
            ubicacion_temporal = '0';
            tituloModulo = "Devolucion de Cajas"
        }
        else {
            devolucion_cajas = '0'
            retiro_cajas = '0'
            ubicacion_temporal = '0';
            tituloModulo = "Etiquetas"
        }

    }

    const datos = {
        valorMudanza: 1,
        valorUbicacionTemporal: ubicacion_temporal,
        valorRetiroCaja: retiro_cajas,
        valorDevolucionCaja: devolucion_cajas,
    };

    return (
        <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
            <PageHeaderCard title={tituloModulo} icon={<LocalOfferIcon />} />
            <CajasProvider>
                <CajasEtiquetasList datos={datos} />
            </CajasProvider>
        </Grid>
    );
}